import React from 'react';

import Gallonbot from './Gallonbot';
import Galloncaps from './Galloncaps';
import Gallonbottletab from './Gallonbottletab';


const Gallonbottleca = () => {
    return (
        <div>
            <Gallonbot />
            <Galloncaps />
            <Gallonbottletab />
        </div>
    );
};

export default Gallonbottleca;
